import { FC } from 'react';
import { Trans, useTrans } from 'base/utils/i18n';
import { ReferralTitle } from 'mod/referral/ReferralTitle';
import site from 'pro/config/site';
import { CardList } from 'mod/referral/CardList';
import { observer, useStoreState } from 'base/store';
import { RouteEnum } from 'pro/config/routers';

type IReferralBenefitsProps = {
    className?: string;
};

export const ReferralBenefits: FC<IReferralBenefitsProps> = observer((props) => {
    const { className } = props;
    const { t } = useTrans();
    const { referralConfig } = useStoreState('persistStore')
    const userStore = useStoreState('userStore');
    const { pointsRule } = userStore

    return (
        <div className={className}>
            <ReferralTitle>{t('web_referral_benefit', { brand: site.brand })}</ReferralTitle>
            <CardList
                list={[
                    {
                        icon: 'file-asset/file/bf01d8a500bf2305d22ad5a50645115a.svg',
                        title: t('web_referral_benefit_point1'),
                        desc: t('web_referral_benefit_point1_description'),
                    },
                    {
                        icon: 'file-asset/file/9f399272d3952d3fd2808aa60d21fc5d.svg',
                        title: t('web_referral_benefit_point2'),
                        desc: t('web_referral_benefit_point2_description', {
                            points: +pointsRule.obtainPoints * referralConfig.referralPointsPercent,
                            price: pointsRule.obtainPointsPrice
                        }),
                    },
                    {
                        icon: 'file-asset/file/d6bdf733304ef5729f2f9419099f0b6a.svg',
                        title: t('web_referral_benefit_point3'),
                        desc: (
                            <Trans
                                i18nKey="web_referral_benefit_point3_description"
                                values={{
                                    brand: site.brand,
                                    points: +pointsRule.consumePoints,
                                    price: pointsRule.consumePointsPrice
                                }}
                                components={{
                                    'points-marketplace': <a href={RouteEnum.POINTS_MALL}/>
                                }}
                            />
                        )
                    },
                ]}
            />
        </div>
    )
});
